import React from "react";
import { useSelectedNotebookPage } from "../../hook/page";
import {
  useFetchDatabasePrimaryKeyListener,
  useFetchDatabaseViewsListener,
  useFetchFolderSecIndexesListener,
} from "../../hook/page/property";
import { useSelectedDatabaseViewId } from "../../hook/page/view";
import { useFetchViewSettingListener } from "../../hook/page/viewSetting";

import { NotePageContainer, NotePageHeader } from "../note";
import { DatabaseViews } from "./view";
import { PageComponentProperty } from "./component";

export const NotebookDatabasePage: React.FC = () => {
  useFetchDatabaseViewsListener();
  useFetchDatabasePrimaryKeyListener();
  useFetchFolderSecIndexesListener();
  const [selectedViewId] = useSelectedDatabaseViewId();
  useFetchViewSettingListener(selectedViewId);
  const page = useSelectedNotebookPage();
  const pageId = page?.["page-id"];

  return (
    <>
      <NotePageContainer>
        <NotePageHeader pageId={pageId} />
        <PageComponentProperty />
        <DatabaseViews />
      </NotePageContainer>
    </>
  );
};
